import MembersManagerContainer from "../../container/admin/members-manager";

const MembersManager = () => {
    return <MembersManagerContainer />;
};

export default MembersManager;